import { ChartOptions, PlaceholderOptions, TextOptions } from "pptxgenjs"
import * as Constants from "./constants"

export function getChartBaseOptions(
	bodyOptions: PlaceholderOptions,
	dataLabelPosition: "b" | "bestFit" | "b" | "ctr" | "inBase" | "inEnd" | "l" | "outEnd" | "r" | "t" | null = "inEnd"
): ChartOptions {
	const options: ChartOptions = {
		x: bodyOptions.x,
		y: bodyOptions.y,
		w: bodyOptions.w,
		h: bodyOptions.h,
		catAxisLabelFontFace: Constants.SUB_FONT_FACE,
		legendFontFace: Constants.SUB_FONT_FACE,
		shadow: "none",
		showLegend: true,
		showPercent: true,
		showTitle: true,
		titleColor: Constants.DEFAULT_TEXT_COLOR,
		titleFontFace: Constants.SUB_FONT_FACE,
		titleFontSize: (bodyOptions as TextOptions).fontSize,
		valAxisLabelFormatCode: Constants.STRING_FORMAT_CURRENCY,
		valAxisLabelFontFace: Constants.DEFAULT_FONT_FACE
	}

	if (dataLabelPosition) options.dataLabelPosition = dataLabelPosition

	return options
}

export function getChartFirstOfTwoOptions(
	bodyOptions: PlaceholderOptions
): ChartOptions {
	const options = getChartBaseOptions(bodyOptions)
	options.w = (bodyOptions.w as number) / 2
	options.legendPos = "b"
	options.showPercent = true;
	options.dataLabelFontBold = true;

	return options
}

export function getChartSecondOfTwoOptions(
	bodyOptions: PlaceholderOptions
): ChartOptions {
	const options = getChartBaseOptions(bodyOptions)
	options.x = (bodyOptions.x as number) + (bodyOptions.w as number) / 2
	options.w = (bodyOptions.w as number) / 2
	options.legendPos = "b"
	options.showPercent = true;
	options.dataLabelFontBold = true;

	return options
}

export function getChartColors():string[]{
	return [
		"9bbb59",
		"4f81bd",
		"c0504d",
		"8064a2",
		"4bacc6",
		"f89d52",
		"2c4d75",
		"235833",
		"855005",
		"d284b9",
		"632621"
	]
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/pptx-configuration/charts.ts